(() => {
  document.querySelectorAll('[data-katarsis-product]').forEach((root) => {
    const select = root.querySelector('[data-katarsis-date]');
    const quantityInput = root.querySelector('[data-katarsis-quantity]');
    const unitPrice = root.querySelector('[data-katarsis-unit-price]');
    const total = root.querySelector('[data-katarsis-total]');
    const booking = root.querySelector('[data-katarsis-booking]');
    const empty = root.querySelector('[data-katarsis-empty]');
    const loadError = root.querySelector('[data-katarsis-load-error]');
    const submit = root.querySelector('.katarsis-product__submit');

    const formatMoney = (minorUnits) => {
      const formatter = new Intl.NumberFormat(root.dataset.locale || 'es-ES', {
        style: 'currency',
        currency: root.dataset.currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(minorUnits / 100);
    };

    const updateTotal = () => {
      if (!quantityInput || !total) return;
      const quantity = Math.max(1, Math.floor(Number(quantityInput.value) || 1));
      quantityInput.value = quantity;
      const currentPrice = select
        ? Number(select.selectedOptions[0]?.dataset.unitPrice || 0)
        : Number(total.dataset.unitPrice || 0);
      if (unitPrice && select) {
        unitPrice.dataset.unitPrice = currentPrice;
        unitPrice.textContent = formatMoney(currentPrice);
      }
      total.textContent = formatMoney(currentPrice * quantity);
    };

    const sortDates = (preserveSelection) => {
      if (!select) return;
      const requestedVariant = root.dataset.requestedVariant || '';
      const currentValue = preserveSelection ? select.value : '';
      const options = Array.from(select.options);
      options.sort((a, b) => Number(a.dataset.date || 0) - Number(b.dataset.date || 0));
      options.forEach((option) => select.appendChild(option));
      const hasRequested = requestedVariant && options.some((option) => option.value === requestedVariant);
      const hasCurrent = currentValue && options.some((option) => option.value === currentValue);
      if (hasRequested) {
        select.value = requestedVariant;
      } else if (hasCurrent) {
        select.value = currentValue;
      } else if (options.length) {
        select.value = options[0].value;
      }
    };

    select?.addEventListener('change', updateTotal);
    quantityInput?.addEventListener('input', updateTotal);
    quantityInput?.addEventListener('change', updateTotal);

    const loadOtherVariantPages = async () => {
      const pageCount = Number(root.dataset.pageCount || 1);
      const sectionId = root.dataset.sectionId;
      if (!select || root.dataset.privateBooking === 'true' || pageCount < 2 || !sectionId) return;

      root.classList.add('is-loading-dates');
      const knownIds = new Set(Array.from(select.options).map((option) => option.value));

      try {
        for (let page = 2; page <= pageCount; page += 1) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', String(page));
          url.searchParams.set('sections', sectionId);
          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error('Katarsis date page request failed');
          const sections = await response.json();
          const html = sections[sectionId];
          if (!html) throw new Error('Katarsis section response was empty');

          const documentPage = new DOMParser().parseFromString(html, 'text/html');
          const pageOptions = documentPage.querySelectorAll('[data-katarsis-date] option[data-date]');
          pageOptions.forEach((option) => {
            if (!knownIds.has(option.value)) {
              select.appendChild(option.cloneNode(true));
              knownIds.add(option.value);
            }
          });
        }

        sortDates(false);
        if (booking) booking.hidden = select.options.length === 0;
        if (empty) empty.hidden = select.options.length > 0;
        if (loadError) loadError.hidden = true;
        if (select.options.length) {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (error) {
        if (booking && select.options.length) booking.hidden = false;
        if (empty) empty.hidden = true;
        if (loadError) loadError.hidden = false;
      } finally {
        root.classList.remove('is-loading-dates');
      }
    };

    updateTotal();
    if (select && Number(root.dataset.pageCount || 1) < 2) sortDates(true);
    loadOtherVariantPages();

    if (submit && root.querySelector('form')) {
      root.querySelector('form').addEventListener('submit', () => {
        submit.setAttribute('aria-disabled', 'true');
        submit.setAttribute('aria-busy', 'true');
      });
    }

    const motionTarget = root.querySelector('[data-katarsis-motion]');
    if (motionTarget && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('has-motion');
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          root.classList.add('is-visible');
          observer.disconnect();
        }
      }, { threshold: 0.18, rootMargin: '0px' });
      observer.observe(root);
    }
  });
})();
